// import { useContext } from 'react';
// import { GlobalContext } from '../../../App';

const useGeneralQueries = () => {
//   const { 
//     // token, setLoading, 
//     // setNameBlocks, setDataBlocks
//  } = useContext(GlobalContext);

  const extractAndSaveData = (key, data, father = '') => {
    return data
      ? data
          .map((item) => {
            return { key: item['id'].toString(), father: item[father], value: item[key] }; // שימוש ב-[id] כדי להציב את ערך id כמפתח
          })
          .filter((name) => name != null)
      : null;
  };
//   // קבלת כל הרשומות
//   const AllData = (url, nameData, nameColume) => {
//     let isError = (err) => {
//       if (err) {
//         console.log('שגיאה: ', err);
//       }
//     };
//     let isPending = (pending) => {
//       (localStorage.getItem(nameData) === null || !pending) && setLoading(pending);
//       console.log(pending ? 'בטעינה...' : 'סיים טעינה');
//     };
//     let getData = (response) => {
//       localStorage.setItem(nameData, JSON.stringify(response));
//       setDataBlocks(response);

//       let filterName = extractAndSaveData(nameColume, response);
//       localStorage.setItem(nameData, JSON.stringify(filterName));
//       setNameBlocks(filterName);
//     };
//     GetAllItems(url, { token }, isPending, getData, isError);
//   };

//   // קבלת כל הרשומות
//   const GetAllItems = async (url, { token }, isPending = () => {}, getData = () => {}, isError = () => {}) => {
//     isPending(true);

//     await fetch(url, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ token: token })
//     })
//       .then((res) => {
//         if (!res.ok) {
//           throw Error('Error GetAllItems', res);
//         }
//         if (!res) {
//           throw Error('Error GetAllItems', res);
//         }
//         return res?.json();
//       })
//       .then((resData) => {
//         getData(resData);
//         isError(false);
//         isPending(false);
//       })
//       .catch((err) => {
//         isError(err.message);
//         isPending(false);
//       });
//   };

  // הוספת ו/או עדכון רשומה חדשה
  const AddItem2 = async (url, data, { token, payload }, isPending = () => {}) => {
    isPending(true);
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: payload?.actionType === 'UPDATE' ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data, token, payload })
      })
        .then((res) => {
          if (!res.ok) {
            reject('Error AddItem', res);
          }
          if (!res) {
            reject('Error AddItem', res);
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  const AddItem = async (url, data, { token, payload }, isPending = () => {}) => {
    isPending(true);
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: payload?.actionType === 'UPDATE' ? 'PUT' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data, token, payload })
      })
        .then(async (res) => {
          if (!res.ok) {
            reject(`Error AddItem: ${res.statusText}`);
          } else {
            const responseData = await res.json(); // קבלת התגובה מהשרת
            resolve(responseData); // החזרת התגובה
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  // setAllItems
  const setAllItems = async (url, data, { token }, isPending = () => {}, isError = () => {}, callbacks) => {
    isPending(true);

    console.log('step 1 add - ', data);

    return new Promise((resolve, reject) => {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data, token })
      })
        .then((res) => {
          if (!res.ok) {
            reject('test error');
          }
          if (!res) {
            reject('test error 2');
          }
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  // מחיקת רשומה ספציפית
  const RemoveItem = async (url, id, { token }, isPending = () => {}, isError = () => {}) => {
    isPending(true);
    await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, token: token })
    })
      .then((res) => {
        if (!res.ok) {
          throw Error('test error', res);
        }
        if (!res) {
          throw Error('test error 2', res);
        }
        isError(false);
        isPending(false);
      })
      .catch((err) => {
        isError(err.message);
        isPending(false);
      });
  };

//   // קבלת רשומה יחידה
//   const GetSingleItem = async (url, { token }, isPending = () => {}, getData = () => {}, isError = () => {}) => {
//     isPending(true);

//     await fetch(url, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ token: token })
//     })
//       .then((res) => {
//         if (!res.ok) {
//           throw Error('Error GetSingleItem', res);
//         }
//         if (!res) {
//           throw Error('Error GetSingleItem', res);
//         }
//         return res?.json();
//       })
//       .then((resData) => {
//         getData(resData);
//         isError(false);
//         isPending(false);
//       })
//       .catch((err) => {
//         isError(err.message);
//         isPending(false);
//       });
//   };

//   const GetNextAutoIncrement = (url, nameData, nameColume) => {
//     let isError = (err) => {
//       if (err) {
//         console.log('שגיאה: ', err);
//       }
//     };
//     let isPending = (pending) => {
//       (localStorage.getItem(nameData) === null || !pending) && setLoading(pending);
//       console.log(pending ? 'בטעינה...' : 'סיים טעינה');
//     };
//     let getData = (response) => {
//         console.log('test', response);
//         console.log('nameColume: ', nameColume);
        
        
//     //   localStorage.setItem(nameData, JSON.stringify(response));
//     //   setDataBlocks(response);

//     //   let filterName = extractAndSaveData(nameColume, response);
//     //   localStorage.setItem(nameData, JSON.stringify(filterName));
//     //   setNameBlocks(filterName);
//     };
//     GetSingleItem(url, { token }, isPending, getData, isError);
//   };

  return { extractAndSaveData, 
    // AllData,
    //  GetAllItems,
    AddItem, AddItem2, setAllItems, RemoveItem, 
    // GetNextAutoIncrement
 };
};

export default useGeneralQueries;
